module.exports = __webpack_public_path__ + "static/media/walee-logo.95cf10a5.png";